import axios from 'axios'
import store from '@/store'

const BASE_URL = 'https://p5afw4zfc3.execute-api.ap-southeast-1.amazonaws.com/prod/api'
// const BASE_URL = 'http://localhost:3000/api'

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use((config) => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

export default {
  create: async (routeName, data) => {
    try {
      const response = await apiClient.post(`/${routeName}`, data)
      return response.data
    } catch (error) {
      console.error('Create Request Failed:', error)
      throw new Error(error.response?.data?.message || 'An error occurred while creating the resource')
    }
  },
  post: async (routeName, data = {}, config = {}) => {
    try {
      const response = await apiClient.post(`/${routeName}`, data, config)
      return response.data
    } catch (error) {
      console.error('POST Request Failed:', error)
      throw new Error(error.response?.data?.message || error.response?.data?.error || 'An error occurred while posting data')
    }
  },
  update: async (routeName, data) => {
    try {
      const response = await apiClient.put(`/${routeName}/` + data.id, data)
      return response.data
    } catch (error) {
      console.error('Update Request Failed:', error)
      throw new Error(error.response?.data?.message || 'An error occurred while updating the resource')
    }
  },
  login: async (data) => {
    try {
      const response = await apiClient.post('/login', data)
      return response.data
    } catch (error) {
      console.error('Login Request Failed:', error)
      throw new Error(error.response?.data?.message || 'Login failed')
    }
  },
  registerUser: async (data) => {
    try {
      const response = await apiClient.post('/register', data)
      return response.data
    } catch (error) {
      console.error('Register Request Failed:', error)
      throw new Error(error.response?.data?.message || 'Registration failed')
    }
  },
  get: async (routeName, params = {}) => {
    try {
      const response = await apiClient.get(`/${routeName}`, { params })
      return response.data
    } catch (error) {
      console.error('GET Request Failed:', error)
      throw new Error(error.response?.data?.message || 'An error occurred while fetching data')
    }
  },
  delete: async (routeName, params = {}) => {
    try {
      const response = await apiClient.delete(`/${routeName}/` + params)
      return response.data
    } catch (error) {
      console.error('Delete Request Failed:', error)
      throw new Error(error.response?.data?.message || 'An error occurred while deleting the resource')
    }
  }
}

// Named export for registerUser
export const registerUser = async (data) => {
  try {
    const response = await apiClient.post('/register', data)
    return response.data
  } catch (error) {
    console.error('Register Request Failed:', error)
    throw new Error(error.response?.data?.message || 'Registration failed')
  }
}
